import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { motion, useAnimation } from "framer-motion";

const fadeEnd = {
  opacity: 1,
  transition: { delay: 0, duration: 0.15, ease: "easeOut" },
};

const fadeStart = {
  opacity: 0,
  transition: { delay: 0, duration: 0, ease: "easeOut" },
};

const PageTransition = ({ page, children }) => {
  const controls = useAnimation();

  useEffect(async () => {
    await controls.start(fadeStart);
    window.parent.postMessage(
      {
        type: "scrollToTop",
      },
      "*"
    );
    window.scrollTo(0, 0);
    controls.start(fadeEnd);
  }, [page]);

  return <motion.div animate={controls}>{children}</motion.div>;
};

PageTransition.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.number.isRequired,
};

export default PageTransition;
